import { memo } from "react";
import { StyleSheet } from "react-native-unistyles";
import { View, Button, Banner } from "@src/components";

interface TenantAdminConfirmContentProps {
  onConfirm: () => void;
}

export const TenantAdminConfirmContent = memo(({ onConfirm }: TenantAdminConfirmContentProps) => {
  return (
    <View>
      <Banner
        title="Grant organisation admin"
        variant="info"
        message="Granting organisation admin gives this user full administrative access to all sites, cameras, and user permissions across the organisation."
        containerStyle={styles.bannerContainer}
      />
      <Button variant="primary" label="Confirm" size="md" onPress={onConfirm} />
    </View>
  );
});

const styles = StyleSheet.create((theme) => ({
  bannerContainer: {
    marginBottom: theme.spacing.xl,
  },
}));
